module.exports = __webpack_public_path__ + "img/logo_mines_foundation_stack.538b0146.png";